import WbHttpClient from './wbhttpclient';

class KpiService {
  constructor() {
    this.WbHttpClient = new WbHttpClient();
  }

  fetchLatestKpiValue(id) {
    return this.WbHttpClient.get(`vnext/kpis-api/kpis/${id}/data/latest`);
  }
}

export default KpiService;
